import { Link } from "react-router-dom";
import type { WorkItem } from "@/types";

export default function WorkCard({ work }: { work: WorkItem }) {
  return (
    <Link
      to={`/works/detail/${work.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`${work.title} 封面`}
          title={`${work.title} 动漫作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
          {work.type}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base truncate group-hover:text-primary-700 transition-colors">
          {work.title}
        </h3>
        <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500 flex-wrap">
          <span>{work.region}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span>{work.year}</span>
        </div>
        <p className="text-xs md:text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
          {work.synopsis}
        </p>
      </div>
    </Link>
  );
}